export default __webpack_public_path__ + "static/media/cosmetics.bf606476.svg";